module.exports = __webpack_public_path__ + "55527477ae18592904560e568822c052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/stryker_2023_chart.png
// module id = 1730
// module chunks = 0